import React, { useState, useEffect } from "react";
import Stack from "@mui/material/Stack";
import Input from "@mui/material/Input";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import SettingsIcon from "@mui/icons-material/Settings";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { EMPLOYEE_BLUE, PINK_RED, WHITE } from "../colors";
import HeightBox from "../components/HeightBox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import EmployeeListContainer from "../containers/EmployeeListContainer";
import SingleUserDetailsContainerEmp from "../containers/SingleUserDetailsContainerEmp";

import CustomModelForResign from "../components/ResignModel";
import CustomModelForAssignRole from "../components/AssignRoleModel";
import { AddNewEmployeeContainerModel } from "../containers/AddNewEmployeeContainerModel";

import EmployeeService from "../services/employeeService";
import {getAllEmployees} from "../actions/employees";
import {getAllRoles} from "../actions/roles";
import RoleService from "../services/roleService";
import ChangePasswordModel from "../components/ChangePasswordModel";
import { EMPLOYEE } from "../constants/userCategory";
import { useDispatch, useSelector } from "react-redux";

const CustomInput = styled(Input)(({ theme }) => ({
  backgroundColor: "#fff",
  paddingLeft: 10,
  height: 50,
  width: 320,
}));
const CustomButton = styled(Button)(({ theme }) => ({
  paddingLeft: 10,
  height: 50,
  minWidth: 155,
  color: WHITE,
  textTransform: "none",
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
}));

const Employees = () => {
  const dispatch = useDispatch();
  const employeeList = useSelector((state) => state.employeeList);
  const roleList = useSelector((state) => state.roleList);
  const roles=roleList.roles;
 
  const { loading: isDataLoaded, error, employees } = employeeList;
  console.log("roles", roles);
  console.log("employees", employees);
  const [userClicked, setUserClicked] = useState(null);
  const [isNewEmployeeAdded, setIsNewEmployeeAdded] = useState(false);
  const [isEmployeeLoaded, setIsEmployeeLoaded] = useState(false);
  const [openResignModel, setOpenResignModel] = useState(false);
  const [openAssignRoleModel, setOpenAssignRoleModel] = useState(false);
  const [openAddNewEmployeeModel, setOpenAddNewEmployeeModel] = useState(false);
  const [openChangePasswordModel, setOpenChangePasswordModel] = useState(false);
  const [modelMessage, setModelMessage] = useState("");
  const [searchedEmployee, setSearchedEmployee] = useState("");

  const [screenInfo, setScreenInfo] = useState({
    screenName: "",
    employees: [],
    searchedEmployees: [],
    roles: [],
  });

  const [employeeSearching, setEmployeeSearching] = useState(false);

  async function handleResignSelectedUser() {
    // call the api and resign the selected user
    await EmployeeService.resignEmployee(userClicked.id);
    setUserClicked({
      ...userClicked,
      role: null,
      Role: null,
    });
  }

  function resignUser() {
    if (userClicked === null) {
      return;
    }
    setModelMessage("Shall we resign " + userClicked?.name);
    setOpenResignModel(true);
  }

  function assignRoleToUser() {
    if (userClicked === null) {
      return;
    }
    setModelMessage("Select role to Assign");
    setOpenAssignRoleModel(true);
  }

  useEffect(() => {

    const getPageInfo = async () => {
      if(employees === undefined || employees===null)
      {
        dispatch(getAllEmployees());
      }

      setIsEmployeeLoaded(true);
      if(roles === undefined || roles===null){

      dispatch(getAllRoles());
      
      }
      setIsEmployeeLoaded(false);

      setScreenInfo({
        ...screenInfo,
        employees: employees,
        searchedEmployees: employees,
        roles: roles,
      });
    };
    getPageInfo();
  }, []);

  useEffect(() => {
    const getPageInfo = async () => {
      dispatch(getAllEmployees());
      setScreenInfo({
        ...screenInfo,
        employees: employees,
        searchedEmployees: employees,
      });
    };

    if (isNewEmployeeAdded) {
      getPageInfo();
      setIsNewEmployeeAdded(false);
    }
  }, [isNewEmployeeAdded]);

  useEffect(() => {
    if (searchedEmployee.length === 0) {
      setEmployeeSearching(false);
    } else {
      const searchedUsers = screenInfo.employees.filter((value) => value?.name.includes(searchedEmployee));
      setScreenInfo({
        ...screenInfo,
        searchedEmployees: searchedUsers,
      });
      setEmployeeSearching(true);
    }
  }, [searchedEmployee]);

  return (
    <div>
      <ChangePasswordModel
        openModel={openChangePasswordModel}
        okFunction={() => {}}
        user={userClicked}
        cancelFunction={() => {
          setOpenChangePasswordModel(false);
        }}
      />
      <AddNewEmployeeContainerModel
        openModel={openAddNewEmployeeModel}
        setIsNewEmployeeAdded={setIsNewEmployeeAdded}
        setOpenAddNewEmployeeModel={setOpenAddNewEmployeeModel}
        roles={roles!==null && screenInfo.roles}
        okFunction={() => {
          setOpenResignModel(false);
          handleResignSelectedUser();
        }}
        cancelFunction={() => {
          setOpenAddNewEmployeeModel(false);
        }}
      />
      <CustomModelForResign
        openModel={openResignModel}
        message={modelMessage}
        okFunction={() => {
          setOpenResignModel(false);
          handleResignSelectedUser();
        }}
        cancelFunction={() => {
          setOpenResignModel(false);
        }}
      />
      <CustomModelForAssignRole
        openModel={openAssignRoleModel}
        message={modelMessage}
        roles={screenInfo.roles}
        okFunction={(role) => {
          EmployeeService.assignEmployee(userClicked.id, role);
          setUserClicked({
            ...userClicked,
            role: role,
            Role: {
              id: role,
              name: screenInfo.roles.find((r) => r.id === role)?.name,
            },
          });
          setOpenAssignRoleModel(false);
        }}
        cancelFunction={() => {
          setOpenAssignRoleModel(false);
        }}
      />
      <Stack direction="row" alignItems="center" spacing={3}>
        {userClicked !== null && (
          <IconButton onClick={() => setUserClicked(null)}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <CustomInput
          disableUnderline
          placeholder="Search Employee"
          onChange={(event) => {
            if (!userClicked) {
              setSearchedEmployee(event?.target?.value);
            }
          }}
          value={userClicked?.name}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          }
        />
        {userClicked !== null && (
          <CustomButton style={{ backgroundColor: PINK_RED, fontSize: 14 }} onClick={resignUser}>
            Resign
          </CustomButton>
        )}
        {userClicked !== null && (
          <CustomButton style={{ backgroundColor: EMPLOYEE_BLUE, fontSize: 14 }} onClick={assignRoleToUser}>
            Assign Role
          </CustomButton>
        )}
        <CustomButton
          style={{ backgroundColor: EMPLOYEE_BLUE, fontSize: 14 }}
          onClick={() => {
            setOpenAddNewEmployeeModel(true);
          }}
        >
          Add New Employee
        </CustomButton>
        {userClicked !== null && (
          <IconButton aria-label="settings" onClick={() => setOpenChangePasswordModel(true)}>
            <SettingsIcon fontSize="large" />
          </IconButton>
        )}
      </Stack>
      <HeightBox height={20} />
      {userClicked === null && isEmployeeLoaded && (
        <Box
          sx={{
            width: "100%",
            height: "80vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} />
        </Box>
      )}
      {userClicked === null && !isEmployeeLoaded && (
        <EmployeeListContainer
          userClicked={(row) => {
            setUserClicked(row);
          }}
          employees={employeeSearching ? screenInfo.searchedEmployees : screenInfo.employees}
        />
      )}
      {userClicked !== null && <SingleUserDetailsContainerEmp user={userClicked} userRole={EMPLOYEE} />}
    </div>
  );
};

export default Employees;
